<template>

    <authentication-layout :title="title">

        <validation-errors class="mb-4" />

        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>

        <form @submit.prevent="submit" class="flex flex-col block">

            <Input class="mb-5 w-full"
                type="text"
                :placeholder="__('Email')"
                v-model="form.email"
                autofocus
            />

            <Input class="mb-8 w-full"
                :placeholder="__('Password')"
                type="password"
                v-model="form.password"
                autocomplete="current-password"
            />

            <div class="flex justify-start items-center">

                <Button class="mr-4"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing">

                    {{ title }}

                </Button>

                <Link class=""
                    v-if="canResetPassword"
                    :href="route('password.request')"
                >{{ __('Forgot password?') }}</Link>

            </div>

        </form>

    </authentication-layout>

</template>

<script>
    import { defineComponent } from 'vue'
    import AuthenticationLayout from '../../Layouts/AuthenticationLayout.vue'
    import Input from '../../Components/Auth/Input.vue'
    import Label from '../../Components/Auth/Label.vue'
    import ValidationErrors from '../../Components/Auth/ValidationErrors.vue';
    import Link from '../../Components/Auth/Link.vue';
    import Button from "../../Components/Auth/Button";

    export default defineComponent({
        components: {
            Button,
            AuthenticationLayout,
            Input,
            Label,
            ValidationErrors,
            Link,
        },

        props: {
            canResetPassword: Boolean,
            status: String
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: '',
                    password: '',
                    remember: true
                })
            }
        },

        computed: {

            title() {

                return this.__('Login');

            }

        },

        methods: {
            submit() {
                this.form
                    .post(this.route('login'), {
                        onFinish: () => this.form.reset('password'),
                    });
            }
        }
    })
</script>
